/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect } from 'react';
import { StandardProps } from '@/newcar/ui/contract';
import { Show } from '@/newcar/ui/molecule';
import { ConvertType } from '@/newcar/ui/contract/config';
import * as styles from './index.module.styl';

// ABテスト用の住所検索 ボタンなし、郵便番号入力で自動検索を行う
interface AddressProps extends StandardProps {
  /**
   * @required
   * @type {string}
   * @memberof AddressProps
   */
  id: string;

  /**
   * @required
   * @type {string}
   * @memberof AddressProps
   */
  subid?: string;
  /**
   * @required
   * @type {string}
   * @memberof AddressProps
   */
  label: string;

  /**
   * @required
   * @type {string | number}
   * @memberof AddressProps
   */
  value: string | number;

  /**
   * @default {''}
   * @type {string}
   * @memberof AddressProps
   */
  tooltip?: string;

  /**
   * @default {''}
   * @type {string}
   * @memberof AddressProps
   */
  placeholder?: string;

    /**
   * @default {''}
   * @type {string}
   * @memberof TextFieldProps
   */
  helperText?: string;

  /**
   * @default {}
   * @type {object}
   * @memberof AddressProps
   */
  limit?: {};

  /**
   * @default {''}
   * @type {string}
   * @memberof AddressProps
   */
  errorMessage?: string;

  /**
   * @default {null}
   * @type {ConvertType}
   * @memberof AddressProps
   */
  convert?: ConvertType;

  /**
   * @required
   * @type {(event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>}
   * @memberof TextFieldProps
   */
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void | Promise<void>;

  /**
   * inputの入力内容変更時のコールバック
   * @required
   * @type {(event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>}
   * @memberof AddressProps
   */
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;

  /**
   * @default {null}
   * @type {(event: React.MouseEvent<HTMLAnchorElement>) => void | Promise<void>}
   * @memberof TextFieldProps
   */
  onClearField?: (event: React.MouseEvent<HTMLAnchorElement>) => void | Promise<void>;

  /**
   * 検索ボタン押下時のコールバック
   * @required
   * @type {Function}
   * @memberof AddressProps
   */
  handleFindAddressByPostalCode: Function;

  /**
   * 都道府県市区町村による住所検索モーダルの表示
   * @required
   * @type {Function}
   * @memberof AddressProps
   */
  handleShowAddressModalByPrefecture: Function
}

// 住所検索のinputとbutton
export default function Address(props: AddressProps): JSX.Element {
  const {
    id,
    subid = '',
    label,
    value,
    tooltip = '',
    limit,
    helperText = '',
    className = '',
    placeholder = '',
    errorMessage = '',
    convert,
    onFocus,
    onChange,
    onClearField,
    handleFindAddressByPostalCode,
    handleShowAddressModalByPrefecture,
  } = props;

  // UseEffects
  useEffect(() => {
    const element = document.getElementById(id) as HTMLInputElement;
    element.value = value as string;
  }, []);

  // Functions
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const element = document.getElementById(id) as HTMLInputElement;
    if (convert && event.target.value && event.target.value.length === 7) {
      element.value = convert.function(event.target.value as string, convert.targets);
      handleFindAddressByPostalCode(id, element.value);
    }
    onChange(event);
  };

  const showAddressModalByPrefecture = () => {
    handleShowAddressModalByPrefecture(id);
  };

  // Classes
  let isValiedClass = '';
  if (value && !errorMessage) {
    isValiedClass = styles.isValied;
  }

  function isErrDisplay(): 'true' | 'false' | undefined {
    if (errorMessage !== '') {
      return 'true';
    }
    if (errorMessage === '' && value === '') {
      return undefined;
    }
    if (errorMessage === '' && value !== '') {
      return 'false';
    }
    return undefined;
  }

  return (
    <div className={className}>
      <div className="is-margin-bottom-3">{label}</div>
      <div
        className={`${styles.cInput}`}
        aria-invalid={isErrDisplay()}
      >
        <Show when={helperText !== ''}>
          <p className="is-size-6 is-margin-bottom-3">
            {helperText}
          </p>
        </Show>
        <div className={`is-relative is-margin-bottom-4 ${isValiedClass}`}>
          <input
            id={id}
            name={id}
            {...limit}
            data-gtm={`gtm-newcarform-${id}`}
            className={`${styles.cInputField} is-size-4`}
            placeholder={placeholder}
            type="tel"
            onFocus={onFocus}
            onChange={handleOnChange}
          />
          <a
            id={`${id}_clear`}
            onMouseDown={onClearField}
            className={styles.cInputClear}
            tabIndex={-1}
          />
          <Show when={tooltip !== ''}>
            <div className={`${styles.cInput__tooltip} is-size-6`}>
              {tooltip}
            </div>
          </Show>
          <Show when={errorMessage !== ''}>
            <div className={`${styles.cInputError} is-size-6`}>
              {errorMessage}
            </div>
          </Show>
        </div>
        <div className="column is-full">
          <div className="columns is-mobile">
            <div className="column">
              <a
                className="c-link--arrow vue-show-address-search-btn"
                data-gtm={`gtm-newcarform-${id}Manual`}
                onClick={() => showAddressModalByPrefecture()}
              >
                <span className="c-link__arrow c-arrow" />
                <span
                  className="u-pl-xs"
                  style={{ textDecoration: 'underline' }}
                  data-gtm={`gtm-newcarform-${subid}`}
                >
                  郵便番号不明の方はこちらから検索してください
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
